<a href="https://wa.me/{{this.whatsappNumber}}" *ngIf="this.whatsappNumber!=''" class="whatsapp-float" target="_blank">
    <i class="fa fa-whatsapp my-float"></i>
</a>